import axios from "axios";

// Origin of the backend. Empty string in same-origin deployments (the common
// case), or an absolute origin when REACT_APP_BACKEND_URL is set.
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

// Base URL for all API calls. Resolves to "/api" when same-origin, otherwise
// "<origin>/api". Exported for the few places that build a full URL the browser
// fetches directly (e.g. download links, logout redirect, debug display).
export const API_BASE_URL = `${BACKEND_URL}/api`;

// Routes where a 401 must NOT trigger a redirect to /login (avoids loops and
// lets these pages handle auth errors themselves, e.g. bad-credentials login).
const PUBLIC_PATHS = ["/login", "/signup", "/forgot-password", "/reset-password"];

const isPublicPath = (pathname) =>
  PUBLIC_PATHS.some((p) => pathname === p || pathname.startsWith(p + "/"));

// Single shared axios instance. Auth is cookie-based, so withCredentials is on
// for every request. Components should import this default export and call it
// with short relative paths, e.g. api.get("/jobs/123").
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Centralized 401 handling: any expired/invalid session sends the user to the
// login screen, consistently across the whole app.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 && typeof window !== "undefined") {
      const detail = error?.response?.data?.detail;
      const detailText = typeof detail === "string" ? detail : "";
      if (!detailText.includes("RECONNECT_REQUIRED") && !isPublicPath(window.location.pathname)) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
